import { render, staticRenderFns } from "./FieldModsItem.vue?vue&type=template&id=789aa857&scoped=true"
import script from "./FieldModsItem.vue?vue&type=script&lang=js"
export * from "./FieldModsItem.vue?vue&type=script&lang=js"
import style0 from "./FieldModsItem.vue?vue&type=style&index=0&id=789aa857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789aa857",
  null
  
)

export default component.exports